import React from 'react';

import useTranslate from '../../../common/hooks/useTranslate';

import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';

import { IHeader } from '../types/IHeader';

import InvestorDropdownFilter from '../../ui/filters/investorDropdownFilter/investorDropdownFilter';

import './header.scss';

const Header: React.FC<IHeader> = ({
                                     title,
                                     additionalTitle,
                                     onInvestorChange,
                                     investorDropdown,
                                     children,
                                     investors,
                                   }) => {
  const { t } = useTranslate();

  const handleChange = (event: DropDownListChangeEvent) => {
    if (onInvestorChange) {
      onInvestorChange(event);
    }
  };

  return (
    <div className='header-wrapper'>
      <div className='title-wrapper'>
        <p className='title-head'>{t(title)}</p>
        {additionalTitle && <p className='title-head title-grey'>{t(additionalTitle)}</p>}
        {investorDropdown && <InvestorDropdownFilter onChangeCallback={handleChange} investors={investors} />}
      </div>
      <div className='header-content'>{children}</div>
    </div>
  );
};

export default Header;
